module.exports = __webpack_public_path__ + "static/media/D18_page_02.6905dae.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/D18_page_02.mp4
// module id = D9i7
// module chunks = 0